import { render, staticRenderFns } from "./xhs_note_comments.vue?vue&type=template&id=77a65077"
import script from "./xhs_note_comments.vue?vue&type=script&lang=js"
export * from "./xhs_note_comments.vue?vue&type=script&lang=js"
import style0 from "./xhs_note_comments.vue?vue&type=style&index=0&id=77a65077&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports